var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDextoolscircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 72,
    viewBox: "0 0 68 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_100_607)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "#75A49A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 30.5,
    stroke: "black",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6308 14.2827C29.3042 15.5227 27.4007 16.5719 27.4011 16.6146C27.4021 16.7247 32.985 19.6173 33.1831 19.6102C33.2733 19.6071 33.9272 19.2992 34.6362 18.926L35.9254 18.2476L37.3335 18.988L38.7415 19.7286L41.0473 18.6686C44.5217 17.0714 44.8826 16.8963 44.826 16.8375C44.7509 16.7595 43.5047 16.0746 40.1237 14.2535C38.4897 13.3734 36.9037 12.5105 36.5993 12.3358C36.2949 12.1612 36.0042 12.0208 35.9534 12.0235C35.9027 12.0262 33.9574 13.0429 31.6308 14.2827ZM21.4263 19.6888L19.0044 20.9687V26.5858C19.0044 29.6752 19.0362 32.2029 19.0752 32.2029C19.1141 32.2029 20.3057 31.6744 21.7231 31.0285L24.3004 29.8542V23.9334L25.5598 24.6353C26.5303 25.1758 27.5013 25.7151 28.473 26.2533L30.1267 27.1694L30.8626 26.8289C31.3241 26.6151 31.7847 26.3992 32.2443 26.1812C32.5995 26.0119 33.4714 25.6102 34.1819 25.2882C34.8923 24.966 35.5499 24.6421 35.6432 24.5683C35.767 24.4702 34.2566 23.6163 30.0563 21.4096C26.8902 19.7463 24.1982 18.3906 24.0741 18.3971C23.9499 18.4036 22.7584 18.9848 21.4263 19.6888ZM45.2625 20.0482C43.613 20.81 42.2622 21.4638 42.2607 21.5011C42.2593 21.5383 43.1583 22.0852 44.2587 22.7162C45.359 23.3473 46.2593 23.8975 46.2593 23.9389C46.2593 23.9802 45.2856 24.4629 44.0957 25.0117C42.9056 25.5603 39.8977 26.95 37.4111 28.1L29.0797 31.9528C26.9839 32.9221 25.0948 33.7957 24.8817 33.8945C20.6009 35.877 19.4243 36.4271 19.2627 36.5215C19.1002 36.6166 19.0634 37.1689 19.0345 39.9411L19 43.2474L21.1658 44.3764L23.3316 45.5053L26.3348 44.1187C27.9866 43.3562 29.338 42.6923 29.338 42.6434C29.338 42.5946 29.0328 42.3911 28.6599 42.191C28.2868 41.9909 27.5167 41.548 26.9483 41.2065C26.38 40.865 25.8133 40.5516 25.6889 40.5101C25.5646 40.4686 25.4646 40.3961 25.4666 40.3488C25.4687 40.3017 26.7912 39.659 28.4053 38.9206C31.5404 37.4866 33.9396 36.3813 39.0903 33.9983C41.3936 32.933 43.6971 31.8682 46.0009 30.8042C48.0257 29.8692 50.3798 28.7772 51.2323 28.3776L52.7824 27.651L52.8168 24.307L52.8515 20.9631L50.6548 19.8096C49.4466 19.1753 48.4138 18.6578 48.3597 18.6597C48.3056 18.6614 46.9119 19.2862 45.2625 20.0482ZM52.1939 32.112C51.8702 32.2737 51.2308 32.5766 50.773 32.785C50.3152 32.9933 49.4466 33.3943 48.8427 33.6762L47.7447 34.1885L47.7197 37.1242C47.7058 38.7388 47.6477 40.0527 47.5905 40.0442C47.4606 40.0244 45.4028 38.9447 43.3342 37.8108C41.8413 36.9924 41.7475 36.9599 41.3967 37.1376C41.1939 37.2405 39.9816 37.7967 38.7028 38.3739C37.424 38.951 36.3361 39.4609 36.2849 39.5071C36.2339 39.5531 38.8076 40.9803 42.0044 42.6786L47.8167 45.7664L50.2996 44.4524C51.6651 43.7298 52.8262 43.0706 52.8796 42.9877C53 42.8013 52.9897 31.7923 52.8692 31.8072C52.8215 31.813 52.5176 31.9502 52.1939 32.112ZM38.4445 45.0338C38.0138 45.2232 37.5833 45.4129 37.1528 45.6029C35.8529 46.1782 36.1077 46.1973 34.5612 45.4097C33.5313 44.8852 33.0873 44.7233 32.8946 44.8019C32.75 44.8608 31.506 45.4334 30.1298 46.0743C28.7537 46.7152 27.5801 47.2396 27.5217 47.2396C26.9444 47.2396 27.9042 47.8263 31.6081 49.7377L35.9518 51.9791L37.7794 51.0561C38.7846 50.5483 40.8121 49.5317 42.285 48.7968C43.7578 48.0617 44.9446 47.4413 44.9224 47.4179C44.9 47.3946 43.6659 46.7462 42.1798 45.9772L39.4779 44.579L38.4445 45.0338Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_100_607",
    x: 0,
    y: 0,
    width: 68,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_100_607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_100_607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 40,
    fill: "white",
    transform: "translate(19 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDextoolscircle);
export default __webpack_public_path__ + "static/media/dextoolscircle.d94696e1e8525fadde13d7cb0097b0a8.svg";
export { ForwardRef as ReactComponent };